import './App.css';
import LocationContainer from "./Components/LocationContainer"

function App() {
  return(
    <div className="App">
      <LocationContainer />
    </div>
  )
}

export default App;
